import { appHost } from "@/utils/hosts";

type ChannelAuthorizationRequest = {
    socketId: string;
    channelName: string;
};

type ChannelAuthorizationData = {
    auth: string;
    channel_data?: string;
};

type ChannelAuthorizationCallback = (
    error: Error | null,
    authData: ChannelAuthorizationData | null,
) => void;

export function broadcastingAuthEndpoint(
    host: string = window.location.host,
): string {
    return `${window.location.protocol}//${appHost(host)}/broadcasting/auth`;
}

// On an SPA host a relative /broadcasting/auth never reaches Laravel, so private
// channels must authorize against the app host.
export function authorizeBroadcastChannel(
    { socketId, channelName }: ChannelAuthorizationRequest,
    callback: ChannelAuthorizationCallback,
): void {
    window.axios
        .post<ChannelAuthorizationData>(
            broadcastingAuthEndpoint(),
            { socket_id: socketId, channel_name: channelName },
            { withCredentials: true },
        )
        .then((response) => callback(null, response.data))
        .catch((error: unknown) =>
            callback(
                error instanceof Error
                    ? error
                    : new Error("Broadcasting authorization failed"),
                null,
            ),
        );
}
